import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

/**
 * Dialog de confirmação.
 *
 * Ex:
 *
 * {
 *  title: 'Deseja continuar?',
 *  content: ['Ao continuar, não poderá ser revertido'],
 *  buttons: [{
 *    text: 'CANCELAR',
 *    value: false,
 *    color: ''
 *  },
 * {
 *    text: 'CONFIRMAR',
 *    value: true,
 *    color: 'primary'
 *  }]
 * }
 */
@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html'
})
export class ConfirmDialogComponent {
  /**
   * Construtor.
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) {
    dialogRef.disableClose = true;
  }
}
